<template>
  <div class="drawer">
    <div class="header color" @click="isOpened = !isOpened">
      <label class="label" :class="{ active: isOpened }" v-if="label">{{ label }}</label>
      <div class="delete-position">
        <div @click="closeDelete()">
          <Icon
            v-show="toggDeleteIcon"
            :circle="true"
            customClass="circled-icon-small"
            name="deleteForever"
            size="15"/>
        </div>
        <div v-if="!isReportPage">
          <Icon
            v-show="!isOpened"
            name="arrowRight"
            size="28"
          />
          <Icon
            :fillColor="isOpened?'#00726c':''"
            v-show="isOpened"
            name="arrowDown"
            size="28"
          />
        </div>
        <div v-if="isReportPage">
          <Icon
            style="margin-left: 650px; margin-top: -30px"
            v-show="!isOpened"
            name="arrowRight"
            size="28"
          />
          <Icon
            style="margin-left: 650px; margin-top: -30px"
            :fillColor="isOpened?'#00726c':''"
            v-show="isOpened"
            name="arrowDown"
            size="28"
          />
        </div>
      </div>
    </div>
    <div v-show="isOpened">
      <slot></slot>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    toggDeleteIcon: {
      type: Boolean,
      default: false,
    }
  },
  name: 'placeholder',
  data() {
    return {
      showDelete: false,
      isOpened: false
    };
  },
  computed: {
    isReportPage() {
      return this.$route.name === 'reports';
    }
  },
  methods: {
    closeDelete() {
      this.$emit('cleanInputEvent')
    }
  },
  watch: {
    isOpened: {
      handler(newValue, oldValue) {
        if (!this.isOpened && this.isReportPage) {
          this.$emit('cleanInputEvent')
        }
      },
      deep: true
    }
  }
}
</script>
